import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import {
  SET_GLOBAL_MESSAGE_SUCCESS,
  SET_GLOBAL_MESSAGE_ERROR,
} from "store/resources/global/action";
import { toastr } from "react-redux-toastr";

export function* loginSaga(action: types.LoginUserActionType) {
  try {
    const response = yield call(services.loginUserService, action.payload);
    if (response.data || response.ok) {
      log.info("loginSaga: GOOD!");
      yield put({ type: actions.LOGIN_USER_SUCCESS, response });
    } else if (response.error) {
      throw response;
    } else {
      log.info("loginSaga: BAD!");
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.LOGIN_USER_ERROR, response: error });
  }
}

export function* logoutSaga(action: types.LogoutUserActionType) {
  try {
    const response = yield call(services.logoutUserService);
    if (response.data || response.ok) {
      yield put({ type: actions.LOGOUT_USER_SUCCESS, response });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.LOGOUT_USER_ERROR, response: error });
  }
}

export function* registerAuthyUserSaga(
  action: types.RegisterAuthyUserActionType
) {
  try {
    const response = yield call(
      services.registerAuthyUserService,
      action.payload
    );
    if (response.data) {
      yield put({ type: actions.REGISTER_AUTHY_USER_SUCCESS, response });
      yield put({
        type: SET_GLOBAL_MESSAGE_SUCCESS,
        response: "Two-factor Registration Successful!",
      });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.REGISTER_AUTHY_USER_ERROR, response: error });
    yield put({
      type: SET_GLOBAL_MESSAGE_ERROR,
      response: "Two-factor Registration Failed!",
    });
  }
}

export function* textAuthyOtpSaga(action: types.TextAuthyOtpActionType) {
  try {
    const response = yield call(services.textAuthyOtpService);
    if (response.data) {
      yield put({ type: actions.TEXT_AUTHY_OTP_SUCCESS, response });
      toastr.success("Code Delivered", `Check your device!`);
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.TEXT_AUTHY_OTP_ERROR, response: error });
    toastr.error("Code Not Delivered", `${error.error.message}`);
  }
}

export function* callAuthyOtpSaga(action: types.CallAuthyOtpActionType) {
  try {
    const response = yield call(services.callAuthyOtpService);
    if (response.data) {
      yield put({ type: actions.CALL_AUTHY_OTP_SUCCESS, response });
      toastr.success("Calling Device", `Check your device!`);
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.CALL_AUTHY_OTP_ERROR, response: error });
    toastr.error("Code Not Delivered", `${error.error.message}`);
  }
}

export function* verifyAuthyOtpSaga(action: types.VerifyAuthyOtpActionType) {
  try {
    const response = yield call(services.verifyAuthyOtpService, action.payload);
    if (response.data) {
      yield put({ type: actions.VERIFY_AUTHY_OTP_SUCCESS, response });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.VERIFY_AUTHY_OTP_ERROR, response: error });
    toastr.error("Code Is Not Valid", "Try to request a new code");
  }
}

export function* createPasswordNoAuthSaga(
  action: types.CreatePasswordNoAuthActionType
) {
  try {
    const response = yield call(
      services.createPasswordNoAuthService,
      action.payload
    );
    if (response.data) {
      yield put({ type: actions.CREATE_PASSWORD_NOAUTH_SUCCESS, response });
      toastr.success("Password Updated", `Success`);
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.CREATE_PASSWORD_NOAUTH_ERROR, response: error });
  }
}

export function* resetPhoneSaga(action: types.ResetPhoneActionType) {
  try {
    const response = yield call(services.resetPhoneService, action.payload);
    if (response.data) {
      yield put({ type: actions.RESET_PHONE_SUCCESS, response });
      toastr.success("Mobile Device Deactivated", `Success`);
      yield put({
        type: SET_GLOBAL_MESSAGE_SUCCESS,
        response:
          "Your current mobile device has just been deactivated. Please register a new device on next login.",
      });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.RESET_PHONE_ERROR, error });
    toastr.error("Mobile Device Not Deactivated", `Please try again later.`);
    yield put({
      type: SET_GLOBAL_MESSAGE_ERROR,
      response:
        "Your current mobile device could not be deactivated at this time. Please try again later.",
    });
  }
}

export function* resetOperationEmailNoAuthSaga(
  action: types.ResetOperationEmailNoAuthActionType
) {
  try {
    const response = yield call(
      services.resetOperationEmailNoAuthService,
      action.payload
    );
    if (response.data) {
      yield put({
        type: actions.RESET_OPERATION_EMAIL_NOAUTH_SUCCESS,
        response,
      });
      yield put({
        type: SET_GLOBAL_MESSAGE_SUCCESS,
        response:
          "If the email you specified exists in our system, we've sent a reset link to it",
      });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({
      type: actions.RESET_OPERATION_EMAIL_NOAUTH_ERROR,
      response: error,
    });
    yield put({
      type: SET_GLOBAL_MESSAGE_ERROR,
      response:
        "Reset link could not be delivered at this time, please try again later.",
    });
  }
}
